import { LoadingComponent } from "@pga/pga-component-library";
import { path } from "ramda";
import React, { useState } from "react";
import { Mutation } from "@apollo/client/react/components";
import { Redirect } from "react-router-dom";
import { Col, Row } from "reactstrap";
import styled from "styled-components";
import theme from "../../../theme";
import CheckboxField from "../../FormFields/CheckboxField/CheckboxField";
import { isFormValid } from "../../FormValidation";
import { getSectionData } from "../../FormValidation/utils";
import { getFormStateField } from "../../helpers";
import Button from "../common/Button";
import PgaIcon from "../common/PgaIcon";
import { AddJobApplication } from "../query";
import { isPgaProApplicantGroup, isValidDeadline } from "../utils";
import getConfig from "./config";
import makeJobApplication from "./makeJobApplication";
import UploadResume from "./UploadResume";
import { tosAndAttachmentValid } from "./validation";
import { ErrorPage } from "../../../common/components/ErrorScreen";

const { fonts } = theme;

export const JobApplicationContainer = styled.div`
  line-height: 22px;
  text-align: left;
  padding-bottom: 20px;
`;
JobApplicationContainer.displayName = "JobApplicationContainer";

const Title = styled.div`
  margin-bottom: 5px;
  font-family: ${fonts.body};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: -0.23px;
  line-height: 40px;
`;
const SubTitle = styled.div`
  margin-bottom: 20px;
  font-family: ${fonts.heading};
  font-size: 12px;
  font-weight: bold;
  line-height: 36px;
`;

export const JobApplicationView = (props) => {
  const { dispatch, formState, job, authReady, me } = props;
  const jobId = props.match.params.id;
  const [uploadingFile, setUploadingFile] = useState(false);

  const PgaMembersOnly = isPgaProApplicantGroup(job) && (
    <SubTitle>
      <PgaIcon />
      PGA Member and Associate applicants only
    </SubTitle>
  );

  if (!authReady) return <LoadingComponent />;
  return (
    <JobApplicationContainer id="application-form">
      <Title>Apply for this job</Title>
      {PgaMembersOnly}
      {getConfig(props).map(
        ({ data, key }) => data && <div key={key}>{getSectionData(data)}</div>,
      )}
      <Row>
        <UploadResume
          dispatch={dispatch}
          jobId={jobId}
          error={path(["formState", "error"], props)}
          setUploadingFile={setUploadingFile}
        />
      </Row>
      <Row>
        <Col className="mt-3">
          <CheckboxField
            id="terms"
            name="terms"
            text="I’ve read and accept the terms & conditions"
            checked={getFormStateField(props, "terms")}
            error={!path(["tosErrorText"], formState)}
            errorText={path(["tosErrorText"], formState)}
            onChange={(event) =>
              props.dispatch({
                type: "onChangeCheckbox",
                value: event.target,
                preventDefault: event.preventDefault,
              })
            }
          >
            <div className="terms">
              I’ve read and accept the{" "}
              <a
                href=" https://www.pga.org/pga-employment-center-term-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                terms & conditions
              </a>
            </div>
          </CheckboxField>
        </Col>
      </Row>
      <Row>
        <Col>
          <Mutation mutation={AddJobApplication}>
            {(createJobApplication, { data, loading, error, ...rest }) => {
              if (loading) return <LoadingComponent fullscreen />;
              if (error) return <ErrorPage global error={error} />;
              if (data && data.createJobApplication)
                return <Redirect to="/application/thank-you" />;
              return (
                <Button
                  onClick={() => {
                    const isAttachment = tosAndAttachmentValid(
                      formState.attachments,
                      formState.terms,
                      dispatch,
                    );
                    return (
                      isFormValid(props, getConfig(props)) &&
                      isAttachment &&
                      createJobApplication({
                        variables: makeJobApplication(props.formState, me),
                      })
                    );
                  }}
                  disabled={!isValidDeadline(job) || uploadingFile}
                >
                  {uploadingFile ? "Uploading File..." : "Submit Application"}
                </Button>
              );
            }}
          </Mutation>
        </Col>
      </Row>
    </JobApplicationContainer>
  );
};
JobApplicationView.displayName = "JobApplicationView";

export default JobApplicationView;
